<template>
  <footer
    class="footerContainer"
    :class="{ selfcare }"
  >
    <template v-if="config.public.bnplInstanceType === BNPL_INSTANCE_TYPE.FACTORING">
      <div class="poweredBy">
        powered by
      </div>
      <div class="instaCash">
        mil<span class="cash">pay</span>
      </div>
    </template>
    <template v-if="config.public.bnplInstanceType === BNPL_INSTANCE_TYPE.MERCHANT_FINANCE">
      <div class="poweredBy">
        powered by
      </div>
      <div class="instaCash">
        insta<span class="cash">cash</span>
      </div>
    </template>
  </footer>
</template>

<script setup>
defineProps({
  selfcare: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const config = useRuntimeConfig();
</script>

<style scoped>
.footerContainer {
  position: relative;
  left: 0;
  bottom: 0;
  width: 100%;
  overflow: hidden;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: inherit;
}

@media only screen and (max-width: 792px) {
  .footerContainer {
    background: white;
  }
}
</style>
